// import AsyncStorage from "@react-native-community/async-storage";
import Version from './Version'
import Envi from '../Config/Environment'

let hostPyamentTokenVar = '',
    hostVar = '',
    hostPaymentTokenMobileVar = ''
if(Envi.appStatus === 'PROD')
{
  // for PROD
   hostPyamentTokenVar = 'https://gtw.generali.co.id/gateway/paymentassistant/payment-method/web/'
   hostPaymentTokenMobileVar = 'https://gtw.generali.co.id/gateway/paymentassistant/payment-method/mobile/'
   hostVar = 'https://gtw.generali.co.id/gateway/paymentengine/api/v1'
}
else
{
  // for UAT
  // hostVar = 'http://localhost:8777/api/v1'  
  // hostPyamentTokenVar = 'http://localhost:8080/payment-method/web/'
  hostPyamentTokenVar = 'https://uat-iclick-mdw.generali.co.id/mdw/gateway/paymentassistantsim/payment-method/web/'
  hostPaymentTokenMobileVar = 'https://uat-iclick-mdw.generali.co.id/mdw/gateway/paymentassistantsim/payment-method/mobile/'
  hostVar = 'https://uat-iclick-mdw.generali.co.id/mdw/gateway/paymentenginesim/api/v1'  
}

class ApiPayment {
  static hostPaymentTokenMobile = hostPaymentTokenMobileVar
  static hostPyamentToken = hostPyamentTokenVar
  static host = hostVar

  // for uat
  // static hostPyamentToken= 'https://uat-iclick-mdw.generali.co.id/mdw/gateway/paymentassistantsim/payment-method/web/'
  // static host = 'https://uat-iclick-mdw.generali.co.id/mdw/gateway/paymentenginesim/api/v1'

  // for prod
  // static hostPyamentToken= 'https://gtw.generali.co.id/gateway/paymentassistantsim/payment-method/web/'
  // static host = 'https://gtw.generali.co.id/gateway/paymentenginesim/api/v1'


  static token = ''

  static headers() {
    return {
      "Content-Type": "application/json",
      // 'Authorization' : `Bearer ${}`
    };
  }

  static headersJWT() {
    // const token = AsyncStorage.getItem('@jwt')
    return {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${this.token}`,
    };
  }

  static get(route) {
    return this.xhr(route, null, "GET");
  }

  static put(route, params) {
    return this.xhr(route, params, "PUT");
  }

  static post(route, params) {
    return this.xhr(route, params, "POST");
  }

  static delete(route, params) {
    return this.xhr(route, params, "DELETE");
  }

  static async xhr(route, params, verb) {
    const url = `${this.host}/${route}`;
    let options = Object.assign(
      { method: verb },
      verb != "GET" && params ? { body: JSON.stringify(params) } : null,
    );
    // options.headers = url.includes(this.routeHelper) ? url.includes(this.routeHelperAuth) ? Api.headersJWT() : Api.headers() : Api.headersJWT()

    var timeOut = new Promise(function (resolve, reject) {
      setTimeout(
        () =>
          reject(
            {
              "status": false,
              status_message: "Connection Timeout, Harap Coba Lagi!",
              url: url,
              httpStatus: 500,
            },
          ),
        30000,
      );
    });

    var fetcher = new Promise(function (resolve, reject) {
      fetch(url, options)
        .then((response) =>
          response.json().then((data) => ({
            url,
            params,
            data,
            status: true,
            httpStatus: response.status,
          }))
        )
        .then((res) => {
          resolve(res);
        })
        .catch(function (error) {
          if (error == "TypeError: Network request failed") {
            reject(
              {
                status: false,
                status_message: "Connection Timeout, Harap Coba Lagi!",
                url: url,
                httpStatus: 500,
              },
            );
          } else {
            reject(
              {
                status: false,
                status_message: "Error Response",
                url: url,
                httpStatus: 500,
              },
            );
          }
        });
    });

    return Promise.race([fetcher, timeOut])
      .then(function (res) {
        return res;
      })
      .catch(function (error) {
        return {
          status: false,
          status_message: error.status_message,
          url: url,
          httpStatus: 500,
        };
        throw error;
      });
  }

  static FormData(url, data) {
    let headers = new Headers();
    var fetcher = new Promise((resolve, reject) => {
      fetch(this.host + "/" + url, {
        headers: headers,
        method: "POST",
        body: data,
      })
        .then((response) =>
          response.json().then((data) => ({
            data: data,
            status: true,
            httpStatus: response.status,
          }))
        )
        .then((res) => {
          resolve(res);
        })
        .catch(function (error) {
          reject({ status: false, message: error, url: url, httpStatus: 500 });
        });
    });

    return fetcher
      .then(function (res) {
        return res;
      })
      .catch(function (error) {
        return { status: false, message: error, url: url, httpStatus: 500 };
        throw error;
      });
  }
}

export default ApiPayment;
